module.exports = __webpack_public_path__ + "img/ruky.076692b1.svg";